export const DISCLOSURE_ACCOUNTING = 66;
export const DISCLOSURE_EVENT = 43;
export const DISABILITY_OR_SOCIAL_SECURITY = 31;
export const AUDIT = 53;
export const INTERNAL = 21;

/**
 * AB#35289 (AC5): requestor-TYPE id used to scope the Quick Entry requestor
 * search to Internal requestors. This is distinct from {@link INTERNAL} (21),
 * which is the request-TYPE id; 5005 identifies the requestor's type. Single
 * source of truth shared by the QE auto-match (DataEntryDetails) and the
 * classic-reuse search modal (DataEntryDetailsRightPane).
 */
export enum TypeOfRequestorID {
    INTERNAL = 5005,
}

export interface RequestPurpose {
    id: number,
    name: string,
    /**
     * @deprecated Not set by the API in all cases. Use `RequestType`.
     */
    typeID: number,
    /**
     * @deprecated Not set by the API in all cases. Use `RequestType`.
     */
    typeName: string,
}

export interface RequestType {
    id: number,
    name: string,
    requestPurpose: RequestPurpose[],
}

export interface RequestPurposeUpdate {
    organizationId: number,
    requestBufferId: number,
    requestPurposeId: number,
    clearFeeOk: boolean,
    /**
     * AB#37853 (D2): ask the API to re-run the purpose-dependent defaults - the fee-schedule
     * default and the release-method evaluator - AFTER this purpose write commits.
     *
     * Optional, and Classic Mode deliberately never sets it: Classic writes the purpose on tab 1,
     * before either evaluator runs, so its defaults already see the correct purpose. Quick Entry
     * persists the purpose last and therefore needs the explicit re-run. Absent in the payload, the
     * API's DTO deserializes it to false.
     */
    reapplyPurposeDefaults?: boolean,
}
